import { createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'
import { getActiveColumns, initColumns, switchColumns } from '../../../helpers/manageColumns/activeColumns'
import { ColumnsStorage } from '../../../helpers/interfaces/ColumnsStorage'

const ColumnsSlice = (prefix: PrefixType, dataType: string) =>
    createSlice({
        name: dataType === 'JOBS' ? `${prefix}/columnsJobs` : `${prefix}/columns`,
        initialState: getActiveColumns(prefix, dataType),
        reducers: {
            init: (state, action) => initColumns(prefix, dataType, action.payload),
            switchColumns: (state, action): ColumnsStorage[] => switchColumns(prefix, dataType, action.payload),
        },
    })

const columns = (prefix: PrefixType, dataType: string) => ColumnsSlice(prefix, dataType).reducer

export const ColumnsActions = (prefix: PrefixType, dataType: string) => ColumnsSlice(prefix, dataType).actions

export default columns
